<template>
    <div class="footer-area-wrapper" :class="FooterStyle">
        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-12 text-center">
                        <a href="https://www.facebook.com/trustami/" title="Facebook" target="_blank" class="hover-style-link block mx-1">
                            <i class="fab fa-facebook-square"></i>
                        </a>
                        <a href="https://de.linkedin.com/company/trustami" title="Linkedin" target="_blank" class="hover-style-link block mx-1">
                            <i class="fab fa-linkedin"></i>
                        </a>
                        <a href="https://www.xing.com/companies/trustamigmbh" title="Xing" target="_blank" class="hover-style-link block mx-1">
                            <i class="fab fa-xing-square"></i>
                        </a>
                        <a href="https://www.youtube.com/channel/UCqfq3TTFWjGg2DbA8U9BJag" title="YouTube" target="_blank" class="hover-style-link block mx-1">
                            <i class="fab fa-youtube-square"></i>
                        </a>
                        <a href="https://twitter.com/trustami_tweets" title="Twitter" target="_blank" class="hover-style-link block mx-1">
                            <i class="fab fa-twitter-square"></i>
                        </a>
                        <a href="https://www.instagram.com/memecommerce_trustami/" title="Instagram" target="_blank" class="hover-style-link block mx-1">
                            <i class="fab fa-instagram"></i>
                        </a>
                    </div>
                    <div class="col-md-12 text-center">
                        <span class="copyright-text">
                            &copy; 2021{{ year }} <b>Trustami GmbH</b>
                            /
                            <a href="https://www.trustami.com/ueber/" target="_blank" class="hover-style-link">{{ $t("footer.about") }}</a>
                            /
                            <a href="https://www.trustami.com/agb/" target="_blank" class="hover-style-link">{{ $t("footer.tos") }}</a>
                            /
                            <a href="https://www.trustami.com/impressum/" target="_blank" class="hover-style-link">{{ $t("footer.site_notice") }}</a>
                            /
                            <a href="https://www.trustami.com/datenschutz/" target="_blank" class="hover-style-link">{{ $t("footer.data_privacy") }}</a>
                            /
                            <a href="mailto:hello@trustami.ai" class="hover-style-link">hello@trustami.ai</a>
                            /
                            <a href="https://www.trustami.com" target="_blank" class="hover-style-link hover-style-link--green">www.trustami.com</a>
                            /
                            <a href="https://www.trustami.ai" target="_blank" class="hover-style-link hover-style-link--green">www.trustami.ai</a>
                        </span>
                        <span class="copyright-text">
                            <a href="https://docs.trustami.ai" target="_blank" class="hover-style-link">{{ $t("footer.documentation") }}</a>
                            /
                            <a href="https://status.trustami.ai" target="_blank" class="hover-style-link" :title="statusText">
                                <span v-if="status === 0" class="status ok"></span>
                                <span v-if="status === 1" class="status partial"></span>
                                <span v-if="status === 2" class="status down"></span>

                                Status
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FooterMain',
        props: ["FooterStyle"],
        data() {
            const year = (new Date()).getUTCFullYear();

            return {
                year: year !== 2021 ? ' - ' + year : '',
                status: 0,
                statusText: "All systems operational"
            };
        },
        methods: {
            updateStatus() {
                fetch('https://status.trustami.ai/summary.json')
                    .then(response => response.json())
                    .then(data => {
                        if (data) {
                            if (data.online > 0 && data.online < data.total) {
                                this.status = 1;
                                this.statusText = "Partial system outage";
                            } else if (data.online === 0) {
                                this.status = 2;
                                this.statusText = "Major system outage";
                            } else {
                                this.status = 0;
                                this.statusText = "All systems operational";
                            }
                        } else {
                            this.status = 0;
                            this.statusText = "All systems operational";
                        }
                    });
            }
        },
        mounted() {
            this.updateStatus();
        }
    }
</script>
